export default __webpack_public_path__ + "assets/default-store-logo.svg";